import * as Mod1 from "./discourse/components/workflows-form";
import * as Mod2 from "./discourse/components/workflows-user-modal";
import * as Mod3 from "./discourse/discourse-workflows-public-route-map";
import * as Mod4 from "./discourse/initializers/admin-plugin-configuration-nav";
import * as Mod5 from "./discourse/initializers/post-button-workflows";
import * as Mod6 from "./discourse/initializers/topic-admin-button-workflows";
import * as Mod7 from "./discourse/initializers/workflow-webhook-links";
import * as Mod8 from "./discourse/initializers/workflows-user-modal";
import * as Mod9 from "./discourse/pre-initializers/workflow-transformers";
import * as Mod10 from "./discourse/routes/workflows-form-test";
import * as Mod11 from "./discourse/routes/workflows-form";
import * as Mod12 from "./discourse/services/workflows-node-types";
import * as Mod13 from "./discourse/templates/workflows-form-test";
import * as Mod14 from "./discourse/templates/workflows-form";
const compatModules = {
  "discourse/components/workflows-form": Mod1,
  "discourse/components/workflows-user-modal": Mod2,
  "discourse/discourse-workflows-public-route-map": Mod3,
  "discourse/initializers/admin-plugin-configuration-nav": Mod4,
  "discourse/initializers/post-button-workflows": Mod5,
  "discourse/initializers/topic-admin-button-workflows": Mod6,
  "discourse/initializers/workflow-webhook-links": Mod7,
  "discourse/initializers/workflows-user-modal": Mod8,
  "discourse/pre-initializers/workflow-transformers": Mod9,
  "discourse/routes/workflows-form-test": Mod10,
  "discourse/routes/workflows-form": Mod11,
  "discourse/services/workflows-node-types": Mod12,
  "discourse/templates/workflows-form-test": Mod13,
  "discourse/templates/workflows-form": Mod14,
};
export default compatModules;
